import {countries} from "country-data";

const beautyCountry = code => (code && countries[code.toUpperCase()] !== undefined ?
    `${countries[code.toUpperCase()].emoji} ${countries[code.toUpperCase()].name}` :
    code);

export default beautyCountry